/* exported fetcher */
/* global fetch */

window.fetcher = (function () {
	'use strict';
	function microsoftJSONSerializationFix(key, value) {
		if (typeof value === 'string') {
			const isDate = /Date\(([-+]?\d+[-+]?\d+)\)/.exec(value);
			if (isDate) {
				return new Date(+isDate[1]);
			}
		}
		return value;
	}

	/**
	 *
	 * @param {string} url URL
	 * @param {string} method HTTPMethod
	 * @param {object} [body] Daten, die gesendet werden sollen
	 * @param {string} [contentType] Content-Type
	 *
	 * @returns {Promise<any>} -
	 */
	// ReSharper disable once InconsistentNaming
	function _fetch(url, method, body, contentType) {
		const options = { method: method, referrerPolicy: 'no-referrer', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } };
		if (body) {
			options.body = body;
		}
		if (contentType) {
			options.headers['Content-Type'] = contentType;
		}
		return fetch(url, options).then(async result => {
			const isJson = result && result.headers && result.headers.get('Content-Type') && result.headers.get('Content-Type').split(';')[0] === 'application/json';
			if (result.ok) {
				if (isJson) {
					return result.text().then(jsonText => JSON.parse(jsonText, microsoftJSONSerializationFix));
				}
				return result.text();
			}
			const error = isJson ? await result.json() : await result.text();
			throw { status: result.status, error: error };
		});
	}
	return {
		get: url => _fetch(url, 'GET'),
		post: (url, body, contentType = 'application/json') => _fetch(url, 'POST', body, contentType),
		put: (url, body, contentType = 'application/json') => _fetch(url, 'PUT', body, contentType),
		patch: (url, body, contentType = 'application/json') => _fetch(url, 'PATCH', body, contentType),
		postJson: (url, body) => _fetch(url, 'POST', JSON.stringify(body), 'application/json'),
	};
})();
